import Request from './request';
// import { EventEmitter } from 'eventemitter3';

export default class FileService {
	static instance() {
		if (this._instance) {
			return this._instance;
		}
		return (this._instance = new FileService());
	}

	uploadFile(file) {
		let data = new FormData();
		data.append('file', file, file.fileName);
		return Request.instance().post('/file/upload', data);
	}
}